export default {
  title:
    "Are you an existing customer but do not have access to our website?  Fill in your account information below to gain online access.",
  email: "Email",
  userName: false, // "Password",
  password: false, // "Password",
  confirmPassword: false, //"Confirm Password",
  retailerId: "Account Number",
  billingZip: "Billing Zip Code",
  createUserButton: "Activate Online Access",
  confirmationMessage:
    "Thanks for registering. Check your email to set your password.",
  defaultRequest: {},
};
